import styles from "./RepairModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ChevronDown } from "react-ikonate";
import { useState } from "react";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for confirmation of whitelist on the manage tab of the groups page.
 */

export function RepairModal({ isOpen, onClose, onClick }) {
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="REPAIR MISSING PLUGINS"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.description}>
              Confirm that you would like to sync [ # ] missing members to
              attempt to add them to groups.
            </div>

            <div className={styles.buttonContainer}>
              <button
                className={classNames(styles.button, styles.cancelBtn)}
                onClick={onClose}
              >
                CANCEL
              </button>
              <button className={classNames(styles.button)} onClick={onClick}>
                REPAIR
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

RepairModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
};
